module.exports = __webpack_public_path__ + "static/media/bg-celebrate-our-love-tablet.4f3d35b8.png";